import API from "../api/apiUser";

/**
 * Service for fetching global Homepage data.
 */
export const UserHomepageService = {
    /**
     * Fetches aggregated data for the homepage (albums, gallery, events, press).
     * @returns {Promise<Object>} Homepage data object.
     */
    getHomepageData: async () => {
        try {
            const response = await API.get("/user/homepage");
            return response.data;
        } catch (error) {
            console.error("Error fetching homepage data:", error);
            throw error;
        }
    },

    /**
     * Fetches products filtered by category for the homepage.
     * @param {string} categoryId - The ID of the category or 'ALL'.
     * @returns {Promise<Array>} List of products.
     */
    getProductsByCategory: async (categoryId) => {
        try {
            const response = await API.get("/user/homepage/products", {
                params: { category_id: categoryId }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching category products:", error);
            throw error;
        }
    },

    /**
     * Fetches up to 4 discography items filtered by music type for the homepage.
     * @param {string} type - Music type (e.g. 'Album', 'EP', 'Single') or 'ALL' / omit for all.
     * @returns {Promise<Array>} List of discography items (max 4).
     */
    getDiscographyByType: async (type) => {
        try {
            const params = {};
            if (type && type !== "ALL") params.type = type;
            const response = await API.get("/user/homepage/discography", { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching discography by type:", error);
            throw error;
        }
    }
};
